import React, { useState, useEffect } from 'react';
import Headboard from '../headboard/headboard';
import Headboard1 from '../headboard1/headboard1';
import headboard1Adapter from '../headboard1/adapter/headboard1.adapter';
import Headboard2 from '../headboard2/headboard2';
import headboard2Adapter from '../headboard2/adapter/headboard2.adapter';
import HeadboardButtons from '../headboard-buttons/headboardButtons';
import HeadboardClaustro from '../headboard-claustro/headboardClaustro';
import HeadboardDientelandia from '../headboard-dientelandia/headboardDientelandia';
import HeadboardEspecial from '../headboard-especial/headboardEspecial';
import HeadboardInforme2022 from '../headboard-informe2022/headboardInforme2022';
import HeadboardNull from '../headboard-null/headboardNull';
import HeadboardSalaPrensa from '../headboard-sala-prensa/headboardSalaPrensa';
import HeadboardSalaPrensa2 from '../headboard-sala-prensa2/headboardSalaPrensa2';
import HeadboardSimple from '../headboard-simple/headboardSimple';
import HeadboardTabs from '../headboard-tabs/headboardTabs';
import HeadboardTrees from '../headboard-trees/headboardTrees';
import headboardAniversarioAdapter from '../headboard-aniversario/adapter/headboardAniversario.adapter';
import HeadboardAniversario from '../headboard-aniversario/headboardAniversario';
import headboardInforme2024Adapter from '../headboard-informe2024/adapter/headboardInforme2024.adapter';
import HeadboardInforme2024 from '../headboard-informe2024/headboardInforme2024';
import GlobalContext from '../../../contexts/globalContext';
import { ReferenciaCabecera } from '../../../interfaces/ReferenciaCabecera';
import useLoginGigya from '../../../shared/hooks/useLoginGigya';
import TopbarMenu from '../../molecules/topbar-menu/topbarMenu';
import Header from '../header/header';
import Footer from '../footer/footer'
import useScreenSize from '../../../hooks/useScreenSize';
import useBrowserMode from '../../../shared/hooks/useBrowserMode';
import { OptionsFloatings, MainHero } from '@comfama/comfama-ui-react'
import mainHeroAdapter from './adapters/mainHero.adapter';
import './layout.scss';
import ServiceChannels from '../../molecules/service-channels/service-channels';

interface LayoutInterface {
    children: any;
    headboard?: ReferenciaCabecera;
    isNotRoot?: boolean;
    hideHeaderDesktop: boolean;
    hideHeaderMobile: boolean;
    typeChat?: string;
    menuEspecifico?: string;
    esconderLoggin?: boolean;
    hideSidebar?: boolean;
    footerImg?: string;
    glassHeader?: boolean;
    footerWhite?: boolean;
    footerBlack?: boolean;
    hideBurger?: boolean;
}

const Layout = (props: LayoutInterface) => {
    const [size, setSize] = useState(0);
    const [_superFooter, setSuperFooter] = useState<boolean>(false);
    const gigyaContext = useLoginGigya();
    const screenSize = useScreenSize();
    const { document } = useBrowserMode();

    const doSetSize = (_size: number) => {
        localStorage.setItem('font-size', `${_size}`);
        setSize(_size);
    };

    const context = {
        fontSize: { get: size, set: doSetSize },
        superFooter: { get: _superFooter, set: setSuperFooter },
        gigyaContext: { ...gigyaContext },
    };

    const switchHeadBoard = (headboard: ReferenciaCabecera, superFooter: any) => {
        switch (headboard.tipoCabecera) {
            case 'CabeceraTabs':
                return <HeadboardTabs superFooter={superFooter} {...headboard} />;
            case 'CabeceraBotones':
                return <HeadboardButtons superFooter={superFooter} {...headboard} /> ;
            case 'CabeceraSimple':
                return <HeadboardSimple {...headboard} />;
            case 'CabeceraSalaPrensa':
                return <HeadboardSalaPrensa {...headboard} />;
            case 'CabeceraSalaPrensa2':
                return <HeadboardSalaPrensa2 {...headboard} />;
            case 'CabeceraClaustro':
                return <HeadboardClaustro {...headboard} />;
            case 'CabeceraArboles':
                return <HeadboardTrees {...headboard} />;
            case 'CabeceraDientelandia':
                return <HeadboardDientelandia {...headboard} />;
            case 'CabeceraAsamblea2022':
                return <HeadboardInforme2022 {...headboard} />;
            case 'CabeceraEspecial':
                return <HeadboardEspecial {...headboard} />;
            case 'SinCabecera':
                return <HeadboardNull />;
            case 'Cabecera1':
                return <Headboard1 {...headboard1Adapter(headboard)} />;
            case 'Cabecera2':
                return <Headboard2 {...headboard2Adapter(headboard)} />;
            case 'CabeceraAniversario':
                return <HeadboardAniversario {...headboardAniversarioAdapter(headboard)} />;
            case 'CabeceraAsamblea2024':
                return <HeadboardInforme2024 {...headboardInforme2024Adapter(headboard)} />;
            case 'CabeceraCategoria':
                return <MainHero {...mainHeroAdapter(headboard)} />
            default:
                return <Headboard {...headboard} />;
        }
    };

    useEffect(() => {
        setTimeout(() => {
            let dots = document.querySelectorAll('.slick-dots');
            if (dots) {
                Array.from(dots).forEach((dotset) => {
                    let buttons = dotset.getElementsByTagName('button');
                    Array.from(buttons).forEach((button) => {
                        button.setAttribute('tabIndex', '-1');
                    });
                });
            }
        }, 3000);
    }, []);

    return (
        <GlobalContext.Provider value={context}>
            {!props.typeChat && <ServiceChannels />}
            <Header menuEspecifico={props.menuEspecifico} />
            {screenSize > 968 && <TopbarMenu />}
            <>
                <main className="layout-primary">
                    {props.headboard &&
                        switchHeadBoard(props.headboard, context.superFooter)}
                    {props.children}
                </main>
            </>
            <Footer />
        </GlobalContext.Provider>
    );
};

export default Layout;
